export const INFLATED_OFFSET = 50;
export const MAIN_DRAWER_WIDTH = 240;
export const DIMS_NUM = 256;